import {NFT, START, STOP, TICK} from "messaging/message-types.js";
import {getAllNodesInSub} from 'utils/findNode.js';
import {NUMBER} from 'zobject/data-types.js';
import {zobjectDeleted, zmessageDeleted} from './subpatch/operations.js';
import ZMessage from "zobject/ZMessage.js";
import {
    setPresentationWindowPosition,
    setObjectDragging,
    setPluginsLoaded,
    setBulkWindowPositions,
    setSelectedZObject,
    setZMessages,
    setZObjects,
    setWindowPosition} from 'actions/index.js';
import Pattr from './Pattr.js';

export default superclass => class extends superclass {
    zObjects = [];
    zMessages = [];

    initPattr() {
        this.pattr = new Pattr(this);
    }

    updateZObjectRedux() {
        if (!this.sequencerEngine.isLoading) {
            this.dispatch(
                setZObjects(
                    this.id,
                    [... this.zObjects]));
        }

    }

    updateZMessageRedux() {
        if (!this.sequencerEngine.isLoading) {
            this.dispatch(
                setZMessages(
                    this.id,
                    [... this.zMessages]));
        }
    }

    createZObject(x,y,type,select=true) {
       let zobj = this.newZObject();
        if (type) {
            zobj.text = type;
        }

        if (x && !this.sequencerEngine.isLoading) {
            this.dispatch(
                setWindowPosition(
                    zobj.id,
                    {x,y}));
        }

        if (this.state.spatial.presentationMode) {
            zobj.setAttribute("Include in Presentation", true);
        }

        this.zObjects.push(zobj);
        this.updateZObjectRedux();

        if (x === undefined || y === undefined) {
            return zobj;
        }

        // ux triggered this (user dragged it in)

        // so update w the coordinates and select it

        if (!this.sequencerEngine.isLoading && select) {
            this.dispatch(
                setSelectedZObject(zobj));
        }

       return zobj;
    }

    createZMessage(x,y,dataType,onInput,id,text) {
        let zmessage = new ZMessage(this, dataType,onInput,id);
        if (text) {
            zmessage.text = text;
        }

        if (this.state.spatial.presentationMode) {
            zmessage.setAttribute("Include in Presentation", true);
        }
        
        if (x && !this.sequencerEngine.isLoading) {
            this.dispatch(
                setWindowPosition(
                    zmessage.id,
                    {x,y}));
        }
 
        this.zMessages.push(zmessage);
        this.updateZMessageRedux();

       return zmessage;
    }

    getZObjectsJson(isPreset) {
        return {
            zObjects: this.zObjects
                .filter(x => !x.doNotSave)
                .map(x => x.getJson(isPreset)),
            zMessages: this.zMessages.map(x => x.getJson())
        };
    }

    loadZObjectsJson(json) {
        if (!json) {
            return;
        }
        let {zObjects, zMessages} = json;
        for (let obj of zObjects) {
            let zobject = this.createZObject();
            zobject.fromJson(obj);
        }
        for (let obj of zMessages) {
            let zobject = this.createZMessage();
            zobject.fromJson(obj);
        }
    }

    executeAllMessages() {
        this.zMessages.forEach(
            z => z.execute());
        for (let zobject of this.zObjects) {
            if (zobject.isSubPatch) {
                zobject.effect.zMessages.forEach(
                    z => z.execute());
            }
        }
    }

    deleteNode(node, skipIO) {
        if (!skipIO) {
            let {inletNumber, outletNumber, isInlet, isOutlet} = node;

            if (isInlet) {
                // We are deleting a custom inlet w/in a sub-patch here
                this.deleteInletObject(node, inletNumber);
            } else if (isOutlet) {
                // We are deleting a custom outlet w/in a sub-patch here
                this.deleteOutletObject(node, inletNumber);
            }
        }

        if (!this.zObjects.includes(node) && !this.zMessages.includes(node) &&
            node.zObject) {
            node = node.zObject;
        }

        if (node.plugin) {
            let pluginsLoaded = this.state.plugins.pluginsLoaded.filter(
                x => x !== node.plugin);
            this.dispatch(setPluginsLoaded(pluginsLoaded));
        }

        if (node.pluginViewerFor) {
            node.pluginViewerFor.delete();
        }

        if (this.zObjects.includes(node)) {
            this.propagate(zobjectDeleted(node));
            node.disposeMessaging();
            this.zObjects = this.zObjects.filter(
                x => x !== node);
            this.dispatch(
                setZObjects(
                    this.id,
                    [... this.zObjects]));
            
        }

        if (this.zMessages.includes(node)) {
            this.propagate(zmessageDeleted(node));
            node.disposeMessaging();
            this.zMessages = this.zMessages.filter(
                x => x !== node);
            this.dispatch(
                setZMessages(
                    this.id,
                    [... this.zMessages]));
        }
    }

    scheduleZObjects(time, step) {
        for (let obj of this.sequencerEngine.tickingObjects) {
            obj.sendMessageToInlet([TICK, step, time]);
        }
    }

    stopZObjects() {
        for (let obj of this.zObjects) {
            if (obj.needsTick) {
                obj.sendMessageToInlet([STOP]);
            } else if (obj.effect && obj.effect.zObjects) {
                for (let obj of obj.effect.zObjects) {
                    if (obj.needsTick) {
                        obj.sendMessageToInlet([STOP]);
                    }
                }
            }
        }
    }

    loadBangZObjects() {
        if (this.instances && this.instances.length > 0) {
            return;
        }
        let _a = new Date().getTime();
        for (let obj of this.zObjects) {
            if (obj.needsLoad) {
                if (obj.name === "gl.uniform") {
                    // see if its connected to a number, if so then just send that number
                    let inboundNumbers = Object.values(obj.getInboundNodes()).flat().map(x => x.node).filter(
                        x => x.type === NUMBER);
                    if (inboundNumbers.length === 0) {
                        if (obj.subSequence.implements) {
                            continue;
                        }
                        obj.sendMessageToInlet([START]);
                    } 
                    inboundNumbers.forEach(
                        x => {
                            x.skipLoad = true;
                            x.execute(x.message);
                        });
                } else {
                    obj.sendMessageToInlet([START]);
                }
            } else if (obj.effect && obj.effect.zObjects) {
                obj.effect.loadBangZObjects();
            }
        }
        for (let msg of this.zMessages) {
            if (msg.skipLoad) {
                continue;
            }
            if (msg.type === NUMBER) {
                msg.execute(msg.message);
            }
        }
        let _b = new Date().getTime();
        // console.log("load bang for %s took %s ms", this.zObject ? this.zObject.args[0] : "main", _b-_a);
    }

    loadNFTZObjects() {
        for (let obj of this.zObjects) {
            if (obj.needsNFT) {
                obj.sendMessageToInlet([NFT]);
            } else if (obj.effect && obj.effect.zObjects) {
                for (let obj of obj.effect.zObjects) {
                    if (obj.needsNFT) {
                        obj.sendMessageToInlet([NFT]);
                    }
                }
            }
        }
    }

    startZObjects() {
        for (let obj of this.zObjects) {
            if (obj.needsTick || obj.needsStart) {
                if (!obj.name.includes('subpatch')) {
                    obj.sendMessageToInlet([START]);
                }
            } else if (obj.effect && obj.effect.zObjects) {
                if (!obj.name.includes('subpatch')) {
                    obj.effect.startZObjects();
                }
            }
        }
        for (let msg of this.zMessages) {
            if (msg.type === NUMBER) {
                // msg.execute(msg.message);
            }
        }
    }

    encapsulateObjects(x,y) {
        let pulledElements = this.state.windows.selectedElements;
        let ids = Object.keys(pulledElements);

        // find the objects & messages that match these ids
        let zObjects = ids.map(
            id => this.zObjects.find(z => z.id === id))
            .filter(z => z);

        let zMessages = ids.map(
            id => this.zMessages.find(z => z.id === id))
            .filter(z => z);

        let objects = [
            ... zObjects,
            ... zMessages,
            ...zObjects.filter(e => e.effect)
                .map(e => e.effect)];

        let inletConnections = [];
        let inletNumber = 0;

        let outletConnections = [];
        let outletNumber = 0;

        let inletNames = {};
        let outletNames = {};

        for (let obj of objects) {
            if (!obj.getOutboundNodes) {
                continue;
            }

            if (obj.pad) {
                obj = obj.pad;
            }
            
            let outbounds = obj.getOutboundNodes();
            let inbounds = obj.getInboundNodes();

            for (let type in outbounds) {
                let _outbounds = outbounds[type].filter(
                    ({node}) => !objects.includes(node));

                if (_outbounds.length === 0) {
                    continue;
                }

                // check if any of the outlet connections already created are here...

                let alreadyMadeOutlet = false;
                for (let outletConnection of outletConnections) {
                    if (outletConnection.connections[0].node ===
                        _outbounds[0].node && type === outletConnection.type) {
                        alreadyMadeOutlet = true;
                    }
                }
                
                if (!alreadyMadeOutlet) {
                    outletNumber++;
                    let name = (typeof obj.name === "string" && obj.name) || (obj.zObject && obj.zObject.name);
                    outletNames[outletNumber] = name + "." + type;
                }

                // so these are the outbounds from this type that
                // are NOT in the encapsulation 
                outletConnections.push(
                    {
                        connections: _outbounds,
                        outletNumber,
                        type,
                        object: obj
                    }
                );
            }

            for (let type in inbounds) {
                let _inbounds = inbounds[type].filter(
                    ({node}) => !objects.includes(node));

                if (_inbounds.length === 0) {
                    continue;
                }

                let alreadyMadeInlet = false;
                for (let inletConnection of inletConnections) {
                    if (inletConnection.connections[0].node ===
                        _inbounds[0].node && inletConnection.type === type) {
                        alreadyMadeInlet = true;
                    }
                }
                
                if (!alreadyMadeInlet) {
                    inletNumber++;
                    let name = (typeof obj.name === "string" && obj.name) || (obj.zObject && obj.zObject.name);
                    inletNames[inletNumber] = name + '.' + type;
                }

                // so these are the outbounds from this type that
                // are NOT in the encapsulation 
                inletConnections.push(
                    {
                        connections: _inbounds,
                        inletNumber,
                        type,
                        object: obj
                    }
                );
            }
        }

        let zObject = this.createZObject(x,y);

        // create a subpatcher
        zObject.text = "subpatch";
        let subpatch = zObject.effect;

        // move the zObjects and zMessages from this sub-sequennce
        // to the subpatch

        subpatch.zMessages = [
            ... subpatch.zMessages,
            ... zMessages
        ];

        this.zMessages = this.zMessages.filter(
            x => !zMessages.includes(x));

        subpatch.zObjects = [
            ... subpatch.zObjects,
            ... zObjects
        ];

        this.zObjects = this.zObjects.filter(
            x => !zObjects.includes(x));

        this.updateZObjectRedux();
        this.updateZMessageRedux();

        for (let i=2; i <= inletNumber; i++) {
            let obj = subpatch.newInlet(i);
            obj._text = inletNames[i];
        }

        for (let i=2; i <= outletNumber; i++) {
            let obj = subpatch.newOutlet(i);
            obj._text = outletNames[i];
        }

        subpatch.updateZObjectRedux();
        subpatch.updateZMessageRedux();

        for (let zMessage of zMessages) {
            zMessage.clearMessagingRedux();
            zMessage.subSequence = subpatch;
            zMessage.updateMessagingRedux();

        }

        for (let zObject of zObjects) {
            if (zObject.effect) {
                zObject.effect.clearMessagingRedux();
                if (!zObject.effect.trackMeter && !zObject.effect.tracks) {
                    // ensure its not an actual "track" before mutating
                    // the subsequence instance variable
                    zObject.effect.subSequence = subpatch;
                }
                zObject.effect.updateMessagingRedux();
            }
            zObject.clearMessagingRedux();
            zObject.subSequence = subpatch;
            zObject.updateMessagingRedux();
        }

        /**  
         * Look through the inlet connnections list:
         * 1. disconnect the "connections" nodes from the "object" node
         * for the given "type"
         * 2. connect the "connection" nodes to the inlet given by inletNumber
         * 3. connect the inlet to the "object"
         */

        for (let {connections, type, object, inletNumber} of inletConnections) {
            connections.forEach(
                connection => {
                    object.disconnectInlet(type, connection.node, connection.type);
                    subpatch.connectInlet(
                        "Input " + inletNumber, 
                        connection.node,
                        connection.type);
                });

            let inletObj = subpatch.inletObjects[inletNumber-1];
            object.connectInlet(
                type,
                inletObj,
                "Output");
        }

        /**
         * Do same for outlet connection
         */

        for (let {connections, type, object, outletNumber} of outletConnections) {
            connections.forEach(
                connection => {
                    connection.node.disconnectInlet(connection.type, object, type);
                    connection.node.connectInlet(
                        connection.type,
                        subpatch,
                        "Output " + outletNumber);
                });

            let outletObj = subpatch.outletObjects[outletNumber-1];
            outletObj.connectInlet(
                "Input",
                object,
                type);
        }

        /**
         * Finally update windowPositions so they fit in window
         * And update the redux for this subsequence and the subpatch
         */

        let allPositions = this.state.windows.windowPositions;
        let positions = ids.map(id =>
             allPositions[id]);

        // get min positions
        let minX = Math.min(... positions.map(pos => pos.x));
        let minY = Math.min(... positions.map(pos => pos.y));

        let offsetX = -minX + 100;
        let offsetY = -minY + 100;

        let newPositions = {};
        for (let object of objects) {
            let id = object.id;
            if (!allPositions[id]) {
                continue;
            }
            newPositions[id] = {
                x: allPositions[id].x + offsetX,
                y: allPositions[id].y + offsetY
            };

            object.x = newPositions[id].x;
            object.y = newPositions[id].y;
        }

        this.dispatch(setBulkWindowPositions(newPositions));
    }

    deleteInletObject(object, inletNumber) {
        // Simply mark as "deleted" and disconnnect any connections to the inlet
        object.isDeleted = true;

        // disconnect any edges to the inlet
        let keys = Object.keys(this.inlets);
        let inletToDelete = keys[inletNumber-1];
        this.disconnectFromInlet(inletToDelete);

        this.inletObjects.filter(
            x => !x.isDeleted)
            .forEach(
                (o, i) => o.inletNumber = i+1);

        /*
        let keys = Object.keys(this.inlets);
        let inletToDelete = keys[inletNumber-1];
        this.deleteInlet(inletToDelete);
        this.inletObjects = this.inletObjects.filter(
            o => o !== object);

        this.inletObjects.forEach(
            (o, i) => o.inletNumber = i+1);
            */
    }

    deleteOutletObject(object, outletNumber) {
        let keys = Object.keys(this.outlets);
        let outletToDelete = keys[outletNumber-1];
        this.deleteOutlet(outletToDelete);
        this.outletObjects = this.outletObjects.filter(
            o => o !== object);
        this.outletObjects.forEach(
            (o, i) => o.outletNumber = i+1);
    }

    createZTrack(track, x,y) {
        let obj = this.createZObject(x, y, "track " + (track.trackNumber + 1));
    }

    getMessagingEdgeById(id) {
        let objects = [... this.zObjects, ... this.zMessages];

        for (let object of objects) {
            if (object.effect && object.effect.zObjects) {
                let edge = object.effect.getMessagingEdgeById(id);
                if (edge) {
                    return edge;
                }
            }
            for (let type in object.inlets) {
                let connection = object.inlets[type].connections.find(
                    c => c.id === id);
                if (connection) {
                    return connection;
                }
            }
        }
        return undefined;
    }

    findNodeByName(name, isExact=false) {
        let nodes = getAllNodesInSub(this);
        return nodes.filter(x => typeof x.name === "string" &&
                            (isExact ? x.name === name : x.name.toLowerCase().includes(name.toLowerCase())));
    }

    moveObjectInto(object, x, y) {
        if (object.isInlet || object.isOutlet) {
            return;
        }

        // kill all connections
        for (let type in object.inlets) {
            object.disconnectFromInlet(type);
        }
        for (let type in object.outlets) {
            object.disconnectFromOutlet(type);
        }

        if (object.effect && object.effect.inlets) {
            for (let type in object.effect.inlets) {
                object.effect.disconnectFromInlet(type);
            }
            for (let type in object.effect.outlets) {
                object.effect.disconnectFromOutlet(type);
            }
        }
        
        
        // naive just disconnect the object from verything
        let originalContainer = object.subSequence;
        if (originalContainer.zObjects.includes(object)) {
            originalContainer.zObjects = originalContainer.zObjects.filter(
                x => x !== object);
            this.zObjects.push(object);
        }
        if (originalContainer.zMessages.includes(object)) {
            originalContainer.zMessages = originalContainer.zMessages.filter(
                x => x !== object);
            this.zMessages.push(object);
        }
        this.updateZObjectRedux();
        this.updateZMessageRedux();
        originalContainer.updateZObjectRedux();
        originalContainer.updateZMessageRedux();

        object.subSequence = this;
        if (object.effect) {
            object.effect.subSequence = this;
        }

        this.dispatch(setObjectDragging(undefined));

        if (x && y) {
            this.dispatch(setWindowPosition(object.id, {x,y}));
            this.dispatch(setPresentationWindowPosition(object.id, {x,y}));
        }
    }
}

